import React from 'react';
import { motion } from 'framer-motion';
import { Menu, X, RefreshCw } from 'lucide-react';
import { Button } from '../../../components/ui/button';

const AdminHeader = ({
    sidebarOpen,
    setSidebarOpen,
    activeSection,
    sidebarItems,
    user,
    fetchAllData,
    isMobile
}) => {
    const currentLabel = sidebarItems.find(i => i.id === activeSection)?.label || 'Admin Panel';

    return (
        <header className="bg-card/40 backdrop-blur-xl border border-border/40 rounded-[2rem] p-4 md:p-6 mb-8 flex items-center justify-between shadow-2xl transition-all duration-300">
            <div className="flex items-center gap-4 min-w-0">
                <Button
                    variant="outline"
                    size="icon"
                    onClick={() => setSidebarOpen(!sidebarOpen)}
                    className="w-10 h-10 rounded-xl border-border/60 bg-background/50 text-foreground flex-shrink-0"
                >
                    {sidebarOpen ? <X size={18} /> : <Menu size={18} />}
                </Button>
                <div className="min-w-0">
                    <h1 className="text-xl md:text-2xl font-black text-foreground tracking-tighter leading-none mb-1 md:mb-1.5 truncate">
                        {currentLabel}
                    </h1>
                    {!isMobile && (
                        <div className="flex items-center gap-2 opacity-80">
                            <div className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
                            <p className="text-[10px] font-bold text-muted-foreground uppercase tracking-widest truncate">
                                Admin: <span className="text-primary">{user?.displayName || 'Administrator'}</span>
                            </p>
                        </div>
                    )}
                </div>
            </div>

            <div className="flex items-center gap-3">
                <Button
                    variant="outline"
                    size="icon"
                    onClick={fetchAllData}
                    className="w-10 h-10 rounded-xl border-border/60 bg-background/50 text-foreground"
                    title="Refresh Data"
                >
                    <RefreshCw size={18} className="hover:rotate-180 transition-transform duration-500" />
                </Button>

                <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center text-primary-foreground font-black text-sm shadow-lg shadow-primary/20 cursor-default select-none border-2 border-background">
                    {(user?.displayName || 'A')[0].toUpperCase()}
                </div>
            </div>
        </header>
    );
};

export default AdminHeader;
